"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transition = 'all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86) 0s';
//# sourceMappingURL=animations.js.map